module.exports = __webpack_public_path__ + "static/img/3.3898c281.jpg";